const carouselItems = [
  {
    id: 1,
    title: '2024年度最受欢迎国漫TOP10',
    tag: '年度盘点',
    desc: '《斗罗大陆》《完美世界》《凡人修仙传》领衔，国产漫画的黄金时代已经到来！',
    src: 'https://readdy.ai/api/search-image?query=Collection%20of%20popular%20Chinese%20comic%20characters%20in%20epic%20poses%2C%20golden%20trophy%20and%20ranking%20theme%2C%20warm%20orange%20and%20gold%20celebration%20atmosphere%2C%20clean%20flat%20illustration%20style&width=1000&height=560&seq=carousel-comic-01&orientation=landscape',
  },
  {
    id: 2,
    title: '日漫新番速递：七月不可错过的5部',
    tag: '新番推荐',
    desc: '《咒术回战》《鬼灭之刃》续作来袭，还有多部黑马新作等你发现。',
    src: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20collage%20of%20various%20new%20anime%20characters%20in%20summer%20theme%2C%20vibrant%20colors%2C%20festive%20atmosphere%2C%20warm%20sunlight%20and%20cherry%20blossoms&width=1000&height=560&seq=carousel-comic-02&orientation=landscape',
  },
  {
    id: 3,
    title: '韩漫崛起：从条漫到全球现象级IP',
    tag: '行业观察',
    desc: '《我独自升级》全球屠榜，《全知读者视角》动画化在即，韩国漫画凭什么征服世界？',
    src: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20panels%20displayed%20on%20a%20modern%20smartphone%20screen%2C%20vibrant%20colorful%20artwork%2C%20trending%20charts%20and%20global%20map%20in%20background%2C%20clean%20digital%20illustration&width=1000&height=560&seq=carousel-comic-03&orientation=landscape',
  },
  {
    id: 4,
    title: '下拉式阅读：漫画体验的终极进化',
    tag: '阅读指南',
    desc: '告别翻页卡顿，无缝下拉阅读让追更酣畅淋漓。飞飞漫画独家优化引擎深度解析。',
    src: 'https://readdy.ai/api/search-image?query=Modern%20tablet%20device%20showing%20continuous%20scrolling%20comic%20reading%20interface%20with%20smooth%20animation%20effect%2C%20clean%20minimal%20design%2C%20warm%20ambient%20lighting&width=1000&height=560&seq=carousel-comic-04&orientation=landscape',
  },
  {
    id: 5,
    title: '修仙题材为何经久不衰？深度解读',
    tag: '文化解读',
    desc: '从《凡人修仙传》到《遮天》，修仙漫画的文化密码与读者心理需求全剖析。',
    src: 'https://readdy.ai/api/search-image?query=Mystical%20Chinese%20cultivation%20world%20with%20floating%20mountains%2C%20ancient%20temples%2C%20and%20a%20lone%20cultivator%20silhouette%2C%20ethereal%20golden%20mist%2C%20warm%20amber%20lighting&width=1000&height=560&seq=carousel-comic-05&orientation=landscape',
  },
  {
    id: 6,
    title: '完结推荐：一口气读完的经典神作',
    tag: '完结精选',
    desc: '《鬼灭之刃》《死神》《犬夜叉》等经典完结漫画，完整剧情一次看个够！',
    src: 'https://readdy.ai/api/search-image?query=A%20bookshelf%20filled%20with%20completed%20manga%20volumes%2C%20classic%20characters%20floating%20as%20holograms%20above%20the%20books%2C%20warm%20library%20lighting%2C%20cozy%20reading%20atmosphere&width=1000&height=560&seq=carousel-comic-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选专题</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            编辑精选的深度专题内容，从热门作品到行业观察一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.src}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}